import { render, staticRenderFns } from "./StoryStatisticTipItem.vue?vue&type=template&id=2b495d47&scoped=true&"
import script from "./StoryStatisticTipItem.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticTipItem.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticTipItem.vue?vue&type=style&index=0&id=2b495d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b495d47",
  null
  
)

export default component.exports